<template>
	<div class="client-container">
		<div :style="{ overflow: 'hidden' }">
			<bread-crumb :style="{ float: 'left' }" />
			<a-button
				type="primary"
				shape="round"
				icon="plus"
				:style="{ float: 'right', marginTop: '19px' }"
				@click="addNew"
			>
				新增管理员
			</a-button>
		</div>
		<div class="global-table-container">
			<a-table
				:pagination="showPagination"
				:columns="tableColumns"
				:dataSource="tableDataList"
				:scroll="{ x: 1100, y: 450 }"
			>
				<div slot="admin_flag" slot-scope="text, record">
					<a-icon
						v-if="record.is_admin == 1"
						type="check-circle"
						style="color:#7cb305;"
					/>
					<a-icon
						v-if="record.is_admin != 1"
						type="close-circle"
						style="color:#8c8c8c;"
					/>
				</div>
				<div slot="create_time_txt" slot-scope="text, record">
					{{ $Format(record.create_time) }}
				</div>
				<div slot="action" slot-scope="text, record">
					<div
						v-if="
							record.is_admin == 1 && uid != record.id
						"
					>
						<a-tag color="green">主管理</a-tag>
						<a-button
							v-if="!record.status"
							type="primary"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 1)"
						>
							启用
						</a-button>
						<a-button
							v-if="record.status"
							type="dashed"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 0)"
						>
							禁用
						</a-button>
					</div>
					<div v-if="record.is_admin != 1 || uid == record.id">
						<a-tag color="blue" v-if="uid == record.id" style="margin-right: 0;">自己</a-tag>
						<a-button
							v-if="!record.status"
							type="primary"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 1)"
							style="margin-right: 5px;"
						>
							启用
						</a-button>
						<a-button
							v-if="uid!=record.id"
							type="dashed"
							shape="round"
							size="small"
							@click.stop="handleSetStatus(record, 0)"
							
						>
							禁用
						</a-button>
						<!-- <a-button
							size="small"
							type="primary"
							shape="circle"
							icon="eye"
							title="查看管理员详情"
						></a-button> -->
						<a-button
							size="small"
							title="修改管理员"
							type="primary"
							shape="circle"
							icon="edit"
							@click.stop="handleEdit(record)"
						></a-button>
						<!-- 
            <a-button
              size="small"
              title="删除管理员"
              type="danger"
              shape="circle"
              icon="delete"
            ></a-button>
            -->
						<a-button
							type="primary"
							shape="round"
							size="small"
							@click.stop="bindAuthGroup(record)"
							v-if="uid!=record.id"
						>
							角色
						</a-button>
						&nbsp;
						<!-- <a-button
							type="primary"
							shape="round"
							size="small"
							@click.stop="bindArea(record)"
						>
							大区
						</a-button> -->
					</div>
				</div>
			</a-table>
		</div>
	</div>
</template>
<script>
import updatePanel from "@/views/System/manager/update.vue";
import authGroupPanel from "@/views/System/manager/authGroup.vue";
import areaPanel from "@/views/System/manager/area.vue";

var num = 0;
var pageContext;
export default {
	name: "ManagerMgList",
	computed: {
		platform_type: function() {
			return this.$store.state.user.role == 1 ? "sp" : "cp";
		},
		company_id: function() {
			return this.$store.state.user.companyId;
		},
	},
	data() {
		return {
			uid: localStorage.getItem("uid"),
			showPagination: false,
			pageSearchForm: this.$form.createForm(this),
			loadingSearchCompany: false,
			//检索参数
			tableColumns: [],
			tableDataList: [],
			rowSelection: {
				fixed: true,
				onChange: (selectedRowKeys, selectedRows) => {
					console.log(selectedRowKeys);
				},
			},
		};
	},
	mounted() {
		pageContext = this;
		pageContext.initColumns();
		pageContext.refreshDataList();
	},
	methods: {
		initColumns() {
			pageContext.tableColumns = [
				{
					title: "编号",
					dataIndex: "id",
					key: "id",
					width: "80px",
				},
				{
					title: "主管理",
					key: "is_admin",
					width: "120px",
					scopedSlots: { customRender: "admin_flag" },
				},
				{
					title: "用户名",
					dataIndex: "username",
					key: "username",
					width: "250px",
				},
				{
					title: "昵称",
					dataIndex: "nickname",
					key: "nickname",
				},
				{
					title: "姓名",
					dataIndex: "real_name",
					key: "real_name",
				},
				{
					title: "手机号",
					dataIndex: "phone",
					key: "phone",
					width: "200px",
				},
				{
					title: "创建时间",
					dataIndex: "create_time",
					key: "create_time",
					width: "200px",
					scopedSlots: { customRender: "create_time_txt" },
				},
				{
					title: "操作",
					key: "operation",
					fixed: "right",
					width: "280px",
					scopedSlots: { customRender: "action" },
				},
			];
		},
		async refreshDataList() {
			pageContext.$http
				.post("/ManagerMg/getDataList", {
					platform_type: pageContext.platform_type,
					company_id: pageContext.company_id,
				})
				.then(function(response) {
					if (
						response.data.status === 1 &&
						response.data.data.data_list.length > 0
					) {
						pageContext.tableDataList = response.data.data.data_list;
					}
				})
				.catch(function(error) {
					pageContext.$message.error("请求异常，请检查");
					console.log(error);
				});
		},
		addNew() {
			pageContext.$layer.iframe({
				content: {
					content: updatePanel,
					parent: this,
					data: {
						submitBtnLabel: "新 增",
						platform_type: pageContext.platform_type,
						company_id: pageContext.company_id,
					},
				},
				area: ["550px", "700px"],
				title: "新增管理员",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		handleEdit(record) {
			pageContext.$layer.iframe({
				content: {
					content: updatePanel,
					parent: this,
					data: {
						submitBtnLabel: "保 存",
						itemData: record,
					},
				},
				area: ["550px", "700px"],
				title: "修改管理员",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		bindAuthGroup(record) {
			pageContext.$layer.iframe({
				content: {
					content: authGroupPanel,
					parent: this,
					data: {
						itemData: record,
					},
				},
				area: ["650px", "600px"],
				title: "绑定用户角色",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		bindArea(record) {
			pageContext.$layer.iframe({
				content: {
					content: areaPanel,
					parent: this,
					data: {
						itemData: record,
					},
				},
				area: ["950px", "600px"],
				title: "绑定大区",
				shadeClose: false,
				cancel: () => {
					pageContext.$message.info("操作取消！");
				},
			});
		},
		async handleSetStatus(record, status) {
			pageContext.$http
				.post("/ManagerMg/setStatus", {
					id: record.id,
					status: status,
				})
				.then(function(response) {
					if (response.data.status === 1) {
						pageContext.$message.success(response.data.msg);
						pageContext.refreshDataList();
					}
				})
				.catch(function(error) {
					pageContext.$message.error("请求异常，请检查");
					console.log(error);
				});
		},
	},
};
</script>
<style lang="scss" scoped>
.client-container {
	.ant-btn-circle {
		margin: 0px 5px;
	}
}
</style>
